import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { GenerateAuthForm } from '../../components/GenerateAuthForm';
import { VerifyAuthCodeForm } from '../../components/VerifyAuthCodeForm';
import PageLayout from '../../components/PageLayout';
import { AccountLinkIntentSummary } from '../../components/AccountLinkIntentSummary';
import { Context } from '../../types';

const useStyles: any = makeStyles((theme: any) => ({
  alertContainer: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 2, 0),
    },
  },
  content: {
    borderTop: `1px solid ${theme.palette.grey['300']}`,
    backgroundColor: theme.palette.grey['100'],
    borderRadius: '0 0 4px 4px',
  },
}));

type Props = {
  mobileNumber: string;
  step: number;
  context: Context;
  getPaymentsCode: (mobileNumber: string) => Promise<any>;
  getPaymentsTokenByAuthCode: (values: { pin: string }, mobileNumber: string) => Promise<any>;
  setLoginStep: (step: number) => void;
};

const LinkAccountLogin = (props: Props) => {
  const { mobileNumber, step, context, getPaymentsCode, getPaymentsTokenByAuthCode, setLoginStep } = props;
  const classes = useStyles();
  const [stateError, setErrorState] = useState('');
  const form =
    step === 0 ? (
      <GenerateAuthForm
        getPaymentsCode={getPaymentsCode}
        mobileNumber={mobileNumber}
        stateError={stateError}
        setLoginStep={setLoginStep}
        setError={setErrorState}
      />
    ) : (
      <VerifyAuthCodeForm
        getPaymentsTokenByAuthCode={getPaymentsTokenByAuthCode}
        setLoginStep={setLoginStep}
        mobileNumber={mobileNumber}
        context={context}
        stateError={stateError}
        setError={setErrorState}
      />
    );

  return (
    <PageLayout pageTitle='Link account'>
      <AccountLinkIntentSummary />
      <Grid className={classes.content}>{form}</Grid>
    </PageLayout>
  );
};

export default LinkAccountLogin;
